import { AnyAction, IPartialReducer } from "../../../../core/core-redux/reduxTypes";
import { Wfs3dLayersState } from "../../wfs3dLayers.reducer";
import { BASELINE_LAYER_GROUP, WORKSPACE_LAYER_GROUP } from "../../../../common/selector/layerSelector";

const allLayersCounted = (layersFeatureCount: any, layerCount: any) => {
    const baselineLayerCount = layersFeatureCount[BASELINE_LAYER_GROUP];
    const workspaceLayerCount = layersFeatureCount[WORKSPACE_LAYER_GROUP];

    const baselineLayersCounted =
        baselineLayerCount && Object.entries(baselineLayerCount).length === layerCount[BASELINE_LAYER_GROUP];
    const workspaceLayersCounted =
        workspaceLayerCount && Object.entries(workspaceLayerCount).length === layerCount[WORKSPACE_LAYER_GROUP];

    return baselineLayersCounted && (!workspaceLayerCount || workspaceLayersCounted);
};

export const wfs3dFeatureCountPartialReducer: IPartialReducer<Wfs3dLayersState> = (
    state: Wfs3dLayersState,
    action: AnyAction
) => {
    const layersFeatureCount = state.layersFeatureCount || {};
    const layerGroup = layersFeatureCount[action.layerGroup] || {};

    layerGroup[action.layerName] = { featureCount: action.featureCount };
    layersFeatureCount[action.layerGroup] = layerGroup;

    return {
        layersFeatureCount: layersFeatureCount,
        allLayersCounted: allLayersCounted(layersFeatureCount, state.layerCount),
    };
};
